import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox as JoyCheckbox, FormControl, FormHelperText } from "@mui/joy";
import Typography from "@mui/joy/Typography";

interface FormCheckboxProps {
    name: string;
    label: string;
    rules?: object;
    helperText?: string;
    size?: "sm" | "md" | "lg";
    defaultChecked?: boolean;
}

function Checkbox({
    name,
    label,
    rules = {},
    helperText,
    size = "md",
    defaultChecked = false,
    ...props
}: FormCheckboxProps) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={defaultChecked}
            render={({ field, fieldState }) => (
                <FormControl error={!!fieldState.error} size={size}>
                    <JoyCheckbox {...field} checked={field.value || false} label={label} size={size} {...props} />
                    {helperText && !fieldState.error && (
                        <FormHelperText>
                            <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                                {helperText}
                            </Typography>
                        </FormHelperText>
                    )}
                    {fieldState.error && (
                        <FormHelperText>
                            <Typography level="body-xs" color="danger">
                                {fieldState.error.message}
                            </Typography>
                        </FormHelperText>
                    )}
                </FormControl>
            )}
        />
    );
}

export default Checkbox;
